import { apiService } from './api.service';

export interface Notification {
    id: string;
    type: string;
    title: string;
    message: string;
    actionUrl?: string;
    payload?: Record<string, unknown>;
    read: boolean;
    createdAt: string;
}

export interface NotificationsResponse {
    items: Notification[];
    page: number;
    size: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export const notificationService = {
    async getNotifications(page = 0, size = 20): Promise<NotificationsResponse> {
        const response = await apiService.get<NotificationsResponse>(`/notifications?page=${page}&size=${size}`);
        return response.data;
    },

    async getUnreadCount(): Promise<number> {
        const response = await apiService.get<{ unreadCount: number }>('/notifications/unread-count');
        return response.data.unreadCount;
    },

    async markAsRead(id: string): Promise<void> {
        await apiService.put(`/notifications/${id}/read`);
    },

    async markBatchAsRead(ids: string[]): Promise<void> {
        await apiService.put('/notifications/read-batch', ids);
    },

    async markAllAsRead(): Promise<void> {
        await apiService.put('/notifications/read-all');
    },
};

